import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
  routes: [
      {
        path: '/',
        name: 'Home',
        component: () =>
            import ('@/views/Home')
      },
      {
        path: '/homeOld',
        name: 'homeOld',
        component: () =>
          import ('@/views/HomeOld'),
      },
      {
        path: '/index',
        name: 'index',
        component: () =>
          import ('@/views/Index/Index'),
      },
      {
        path: '/dealCollect',
        name: 'dealCollect',
        meta: {
          keepAlive: true, // 需要缓存
          title: '市场交易汇总'
        },
        component: () =>
          import ('@/views/Deal/DealCollect'),
      },
      {
        path: '/dealDetail',
        name: 'dealDetail',
        meta: {title: '市场交易日汇总表'},
        component: () =>
          import ('@/views/Deal/DealDetail'),
      },
      {
        path: '/testAdd',
        name: 'testAdd',
        component: () =>
          import ('@/views/Test/Add'),
      }
  ]
})
router.afterEach(route => {
  // 从路由的元信息中获取 title 属性
  if (route.meta.title) {
    document.title = route.meta.title;
    // 如果是 iOS 设备，则使用如下 hack 的写法实现页面标题的更新
    if (navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)) {
      const hackIframe = document.createElement('iframe');
      hackIframe.style.display = 'none';
      hackIframe.src = '/static/html/fixIosTitle.html?r=' + Math.random();
      document.body.appendChild(hackIframe);
      setTimeout(_ => {
        document.body.removeChild(hackIframe)
      }, 300)
    }
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js